import type { IFieldDefinition } from '@platform/core/types';

/** Поле-термін (UIUX/field-types/date; прототип cellVM): ключ містить due або deadline чи англійський підпис — «Deadline». */
export function isDeadlineField(field: IFieldDefinition): boolean {
  return /due|deadline/i.test(field.key) || /deadline/i.test(field.label?.en ?? '');
}
